// src/api/services/websites.js - rozšířené a opravené API služby
import apiClient from '../client';

export const websiteService = {
    // Základní CRUD operace pro weby
    getWebsites: () => apiClient.get('/api/websites'),
    addWebsite: (websiteData) => apiClient.post('/api/websites/add', websiteData),
    removeWebsite: (id) => apiClient.delete(`/api/websites/remove/${id}`),

    // Bezpečnostní kontrola
    runSecurityCheck: (id) => apiClient.post(`/api/websites/security-check/${id}`),

    // Zálohy
    getBackups: (id) => apiClient.get(`/api/websites/backup/${id}`),
    createBackup: (id, type = 'full') => apiClient.post(`/api/websites/backup/${id}`, { type }),
    restoreBackup: (id, backupId) => apiClient.post(`/api/websites/backup/${id}/restore/${backupId}`),

    // Monitoring výsledků - opraveno a rozšířeno
    getMonitoringResults: (websiteId, type, limit = 10) => {
        const params = { websiteId, type, limit };
        return apiClient.get(`/api/monitoring/results`, { params });
    },

    // SEO monitoring
    getSeoResults: (websiteId) => apiClient.get(`/api/monitoring/seo/results/${websiteId}`),
    runSeoCheck: (websiteId) => apiClient.post(`/api/monitoring/run/${websiteId}/seo`),
    getSeoHistory: (websiteId, limit = 10) => apiClient.get(`/api/monitoring/seo/history/${websiteId}`, { params: { limit } }),

    // Performance monitoring
    runPerformanceCheck: (websiteId) => apiClient.post(`/api/monitoring/run/${websiteId}/performance`),

    // Spuštění konkrétního typu monitorování
    runMonitoring: (websiteId, type) => apiClient.post(`/api/monitoring/run/${websiteId}/${type}`),

    // Získání detailů o webu
    getWebsiteDetails: (id) => apiClient.get(`/api/websites/${id}`),

    // Získání stavu webu (kombinovaný monitoring)
    getWebsiteStatus: (id) => apiClient.get(`/api/websites/${id}/status`),

    // Pomocná funkce pro logování chyb z API
    logApiError: (error, endpoint) => {
        if (error.response) {
            // Server vrátil odpověď s chybovým kódem (např. 404, 500)
            console.error(`API Error (${endpoint}):`, {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            });
        } else if (error.request) {
            // Požadavek byl odeslán, ale nepřišla žádná odpověď
            console.error(`API No Response (${endpoint}):`, error.request);
        } else {
            // Něco se pokazilo při sestavování požadavku
            console.error(`API Request Error (${endpoint}):`, error.message);
        }
    },
    getApiKey: (websiteId) => apiClient.get(`/api/websites/${websiteId}/api-key`),
    generateApiKey: (websiteId) => apiClient.post(`/api/websites/${websiteId}/generate-api-key`),
    resetApiKey: (websiteId) => apiClient.post(`/api/websites/${websiteId}/reset-api-key`),
};